module.exports = __webpack_public_path__ + "static/img/14000665.3e964749.png";